export const buildenv = {
  deployedAt: '2022-09-12T13:24:30.497Z',
  release: 'development',
}
